module.exports = __webpack_public_path__ + "static/fonts/icomoon.68f092ba.woff";